import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { PRODUCTS, SHOP_CATEGORIES } from '../mock/mock';
import { useCart } from '../context/CartContext';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

export default function Shop({ showFilters = true, limit = null, heading = true }) {
  const { addItem } = useCart();
  const [cat, setCat] = useState('all');
  const products = useMemo(() => {
    let list = cat === 'all' ? PRODUCTS : PRODUCTS.filter((p) => p.category === cat);
    if (limit) list = list.slice(0, limit);
    return list;
  }, [cat, limit]);

  const handleAdd = (e, p) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(p, 1, 'M');
    toast(`${p.name} added to bag`);
  };

  return (
    <section id="shop" className="py-20 md:py-28" style={{backgroundColor: '#7B96B5'}}>
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        {heading && (
          <div className="flex items-end justify-between flex-wrap gap-4 mb-8 md:mb-10">
            <div>
              <p className="font-anton uppercase tracking-[0.3em] text-gold text-xs mb-4">— Official Shop</p>
              <h2 className="mega text-cream text-6xl md:text-8xl">Merch</h2>
            </div>
            <Link to="/shop" className="px-6 py-3 font-anton uppercase tracking-widest text-sm rounded-full border border-cream/40 text-cream hover:bg-cream hover:text-brown transition-colors">
              View All
            </Link>
          </div>
        )}

        {showFilters && (
          <div className="flex flex-wrap gap-2 mb-8 border-b border-cream/15 pb-5">
            {SHOP_CATEGORIES.map((c) => (
              <button key={c.slug} onClick={() => setCat(c.slug)}
                className={`font-anton uppercase tracking-widest text-xs px-4 py-2 border transition-colors rounded-full ${
                  cat === c.slug ? 'bg-cream text-brown border-cream' : 'bg-transparent text-cream border-cream/30 hover:border-cream'
                }`}>
                {c.label}
              </button>
            ))}
          </div>
        )}

        <div className="grid grid-cols-2 gap-4 md:gap-5 max-w-2xl mx-auto">
          {products.map((p) => (
            <Link to={`/shop/${p.slug}`} key={p.id} className="product-card group block">
              <div className={`relative aspect-[4/5] overflow-hidden ${
                p.color === 'pink' ? 'bg-pink' : p.color === 'green' ? 'bg-green' : p.color === 'brown' ? 'bg-brown' : p.color === 'transparent' ? '' : 'bg-cream-2'
              }`}>
                <img
                  src={p.images[0]}
                  alt={p.name}
                  className="product-img w-full h-full object-cover"
                  style={p.color === 'transparent' ? { mixBlendMode: 'lighten' } : undefined}
                />
                {p.badge && (
                  <span className="absolute top-3 left-3 font-anton uppercase tracking-widest text-[10px] bg-cream text-brown px-2 py-1 rounded-full">
                    {p.badge}
                  </span>
                )}
                <button onClick={(e) => handleAdd(e, p)}
                  className="absolute bottom-3 right-3 w-10 h-10 bg-cream text-brown flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 hover:bg-gold hover:text-brown rounded-full"
                  aria-label="add to cart">
                  <Plus className="w-5 h-5" />
                </button>
              </div>
              <div className="mt-3 flex items-start justify-between gap-2">
                <h3 className="font-body text-cream text-sm md:text-[15px] leading-snug">{p.name}</h3>
                <p className="font-display text-cream text-sm md:text-base whitespace-nowrap">${p.price.toFixed(2)}</p>
              </div>
              <p className="font-body text-[11px] uppercase tracking-widest text-cream/60 mt-1">{p.category}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
